import Axios, { AxiosResponse } from "axios";
import Vue from "vue";
import {
  NIPIGE_STORAGE,
  NIPIGE_INVENTORY,
  NIPIGE_SUBSCRIBE,
  NIPIGE_RBAC,
  NIPIGE_ORDER,
  NIPIGE_CATALOG,
  NIPIGE_CAP,
  NIPIGE_CHECKOUT,
  NIPIGE_ADVERTISEMENT,
  NIPIGE_BASE_URL,
  NIPIGE_BULKIMPORT,
  NIPIGE_BUCKET_BASEURL,
  PAYTM_URL

} from "../config/index";

export const BUCKET_BASEURL = NIPIGE_BUCKET_BASEURL;
export const GATEWAY_BASEURL = NIPIGE_BASE_URL;
export const PAYTM_BASEURL = PAYTM_URL;

export const nipige_catalog = Axios.create({
  baseURL: NIPIGE_CATALOG
});

export const nipige_cap = Axios.create({
  baseURL: NIPIGE_CAP
});

export const nipige_inventory = Axios.create({
  baseURL: NIPIGE_INVENTORY
});
export const nipige_subscribe = Axios.create({
  baseURL: NIPIGE_SUBSCRIBE
});
export const nipige_master = Axios.create({
  baseURL: NIPIGE_BASE_URL
});

export const nipige_order = Axios.create({
  baseURL: NIPIGE_ORDER
});

export const nipige_advertisement = Axios.create({
  baseURL: NIPIGE_ADVERTISEMENT
});

export const nipige_storage = Axios.create({
  baseURL: NIPIGE_STORAGE
});
export const nipige_subscriptionpayments = Axios.create({
  baseURL: NIPIGE_SUBSCRIBE
});

export const nipige_rbac = Axios.create({
  baseURL: NIPIGE_RBAC
});

export const nipige_checkout = Axios.create({
  baseURL: NIPIGE_CHECKOUT
});

export const nipige_bulkimport = Axios.create({
  baseURL:NIPIGE_BULKIMPORT
})

const attachJWT = function(config) {
  if (sessionStorage.getItem("userLogin")) {
    const data: any = sessionStorage.getItem("userLogin");
    const { token } = JSON.parse(data);
    config.headers.Authorization = token;
    if (sessionStorage.getItem("nipige:key")) {
      let tenantId = sessionStorage.getItem("nipige:key");
      config.headers["x-encrypted-key"] = tenantId;
    }
    return config;
  } else {
    if (
      sessionStorage.getItem("userRole") === "Partner" &&
      sessionStorage.getItem("nipige:key")
    ) {
      let tenantId = sessionStorage.getItem("nipige:key");
      config.headers["x-encrypted-key"] = tenantId;
    }
    config.headers.Authorization = "";
    return config;
  }
};

nipige_catalog.interceptors.request.use(attachJWT);
nipige_cap.interceptors.request.use(attachJWT);
nipige_inventory.interceptors.request.use(attachJWT);
nipige_master.interceptors.request.use(attachJWT);
nipige_order.interceptors.request.use(attachJWT);
nipige_advertisement.interceptors.request.use(attachJWT);
nipige_storage.interceptors.request.use(attachJWT);
nipige_rbac.interceptors.request.use(attachJWT);
nipige_subscribe.interceptors.request.use(attachJWT);
nipige_subscriptionpayments.interceptors.request.use(attachJWT);
nipige_checkout.interceptors.request.use(attachJWT);
nipige_bulkimport.interceptors.request.use(attachJWT);

export const services = {
  catalog: "catalog",
  nipige: "nipige",
  inventory: "inventory",
  master: "master",
  order: "order",
  advertisement: "advertisement",
  storage: "storage",
  rbac: "rbac",
  subscribe: "subscribe",
  checkout: "checkout",
  bulkimport:"bulkimport",
  subscriptionpayments: "subscriptionpayments"
};

export const serviceResolver = {
  catalog: nipige_catalog,
  nipige: nipige_cap,
  inventory: nipige_inventory,
  master: nipige_master,
  order: nipige_order,
  advertisement: nipige_advertisement,
  storage: nipige_storage,
  rbac: nipige_rbac,
  subscribe: nipige_subscribe,
  subscriptionpayments: nipige_subscriptionpayments,
  checkout: nipige_checkout,
  bulkimport:nipige_bulkimport
};

export const methods = {
  DELETE: "DELETE",
  GET: "GET",
  POST: "POST",
  PUT: "PUT",
  PATCH: "PATCH"
};

export class APIError {
  private message: string;

  constructor(msg) {
    this.message = msg;
  }

  get getMessage() {
    return this.message;
  }
}

export function isValidResponse(resp): boolean {
  return resp && resp.status === 200 && resp.data.status === 1;
}

export const ServiceMaker = async (
  url: string,
  method: string,
  service: string,
  data?: any,
  blob: boolean = false,
  preventError: boolean = false
) => {
  try {
    let result: AxiosResponse;
    const APIInstance = serviceResolver[service];
    if (blob) {
      APIInstance.defaults.responseType = "blob";
    }
    switch (method) {
      case "GET": {
        result = await APIInstance.get(url);
        break;
      }
      case "POST": {
        result = await APIInstance.post(url, data);
        break;
      }
      case "PUT": {
        result = await APIInstance.put(url, data);
        break;
      }
      case "PATCH": {
        result = await APIInstance.patch(url, data);
        break;
      }
      case "DELETE": {
        result = await APIInstance.delete(url, { data });
        break;
      }
      default: {
        throw "InvalidMethod";
      }
    }
    if (!isValidResponse) throw "InvalidResponse";
    return result.data;
  } catch (err) {
    // if (err.response.status === 401) {
    //     router.push('/login')
    // }
    if (!preventError)
      Vue.toasted.error(
        err.response.data.message
          ? err.response.data.message
          : err.response.statusText
      );
    throw new APIError(
      err.response ? err.response.data : "Something went wrong"
    );
  }
};
